import makeApiCall from "./axiosIndex";
const locationMasterApis = {
  fetchLocationWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchAllLocationsBySiteStructureWithPagination",
      method: "get",
      params,
    });
  },

  fetchLocationById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchSiteStructureLocationById`,
      method: "get",
      params: { id },
    });
  },

  updateLocationById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateSiteStructureLocationById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createLocation: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createSiteStructureLocation`,
      method: "post",
      data,
    });
  },

  deleteLocationById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteLocationsByIds",
      method: "delete",
      data: { locationIds: [id] },
    });
  },

  // status
  allowActiveStatus: (id: number): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/activateLocationsByIds`,
      data: { locationIds: [id] },
    }),

  removeActiveStatus: (id: number): Promise<any> =>
    makeApiCall<any>({
      method: "patch",
      url: `/buyer/inActivateLocationsByIds`,
      data: { locationIds: [id] },
    }),
};

export default locationMasterApis;
